module.exports = __webpack_public_path__ + "static/avatar_marcelia-0f2c839961478f75f534cb735fa3e806.png";